import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { GetAccountsRes } from '../models';
import { getAccountsResMock } from './account.mock';
import { ShellApiService } from '../api';

@Injectable()
export class ShellMockApiService extends ShellApiService {
  override getAccounts(): Observable<GetAccountsRes> {
    return of(getAccountsResMock).pipe(delay(500));
  }
}
